import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=7570e61b&scoped=true&"
import script from "./TabGeneral.vue?vue&type=script&lang=ts&"
export * from "./TabGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./TabGeneral.vue?vue&type=style&index=0&id=7570e61b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7570e61b",
  null
  
)

export default component.exports